<template>
  <div class="add_btn font14 font_weight500 colof " @click="addAddress">
    <img src="@/assets/common/icon_add@2x.png" alt="" />
    <span class="font_add">新增收货地址</span>
  </div>
</template>
<script>
export default {
  methods: {
    addAddress() {
      this.$emit("addAddress");
    }
  }
};
</script>

<style lang="less" scoped>
.add_btn {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0 12px 8px;
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 2px;
  padding: 16px 0;
  img {
    width: 12px;
    height: 13px;
    vertical-align: middle;
    margin-right: 4px;
  }
  .font_add {
    vertical-align: middle;
  }
}
</style>
